<mat-card class="mat-card linq-card--legacy">
	<mat-toolbar class="toolbar mat-toolbar-single-row linq-drawer-footer">
		<button class="linq-button linq-button--primary" (click)="loadReportFilters()" type="button">Load Report Setup</button>
		<button class="linq-button linq-button--secondary" [disabled]="this.disableSave" (click)="saveReportFilters()" type="button">Save
			Report Setup</button>
	</mat-toolbar>
</mat-card>